import { afterNextRender, AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FpOrderPanelComponent } from '../fp-order-panel/fp-order-panel..component';
import { FpProcessComponent } from '../fp-process/fp-process.component';
import { register } from 'swiper/element/bundle';
let swiperRegistered = false;

@Component({
    selector: 'app-fp-banner',
    imports: [ TranslateModule, FpOrderPanelComponent ],
    templateUrl: './fp-banner.component.html',
    styleUrl: './fp-banner.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FpBannerComponent {
  images = [1,2,3,4];
  private allImages = Array.from({ length: 21 }, (_, i) => i + 1);

  ngAfterViewInit() {

    if (!swiperRegistered) {
      swiperRegistered = true;
      setTimeout(() => register());
    }

    requestAnimationFrame(() => {
      this.images = this.allImages;
    });
  }
}
